import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import { ScheduleCollectiveCalendarHeaderRow, ScheduleCollectiveCalendarRow } from 'components/Calendar'
import { getCalendarArray } from 'lib/calendar'
import { DayOfWeekType } from 'lib/daysOfWeek'
import { endOfMonth, startOfMonth } from 'date-fns'

type Props = {
  activeDates: Date[]
  businessDays: DayOfWeekType[]
  currentMonth: Date
  selectDate: (date: Date) => void
}

const ScheduleCollectiveCalendar: FC<Props> = (props) => {
  const { activeDates, businessDays, currentMonth, selectDate } = props
  const calendar = getCalendarArray(startOfMonth(currentMonth), endOfMonth(currentMonth))

  return (
    <table className={styles.table}>
      <thead>
        <ScheduleCollectiveCalendarHeaderRow />
      </thead>
      <tbody>
        {calendar.map((row, rowNum) => (
          <ScheduleCollectiveCalendarRow
            key={rowNum}
            activeDates={activeDates}
            businessDays={businessDays}
            currentMonth={currentMonth}
            row={row}
            selectDate={selectDate}
          />
        ))}
      </tbody>
    </table>
  )
}

export default ScheduleCollectiveCalendar
